import { maybe } from '@passionware/monads';
import { useRouteMatch } from 'react-router-dom';
import { WithWorkspace } from 'v5/api/_common/query/workspace';
import { myRouting } from 'v5/features/core/routing';
import { Nullable } from 'v5/platform/typescript';

/**
 * This function provides a stable and reliable way to determine
 * the current team ID. It is designed to function correctly
 * outside of routing contexts and is also capable of operating
 * on unauthenticated pages. The function prioritizes team
 * identification from URL parameters, falling back to Redux
 * state selection if necessary.
 */
export function useCurrentTeamName(): Nullable<string> {
  const normalMatch = useRouteMatch<{ app_id: string }>(
    myRouting.forWorkspace().root() + '/*'
  );
  const settingsMatch = useRouteMatch<{ app_id: string }>(
    myRouting.forWorkspace().settings().root() + '/*'
  );

  return maybe.getOrNull(
    // settings match goes first, otherwise we can match `settings` as a workspace id
    settingsMatch?.params.app_id || normalMatch?.params.app_id
  );
}

export function withWorkspace<TProps extends {}>(
  Component: React.ComponentType<TProps & WithWorkspace>
): React.ComponentType<TProps> {
  return function WithWorkspace(props: TProps) {
    const workspace = useCurrentTeamName();
    if (!workspace) {
      return null;
    }
    return <Component {...props} workspace={workspace} />;
  };
}
